<template>
  <slot v-if="ready" />
</template>

<script setup>
import {
  inject, onUnmounted, watchEffect,
} from 'vue';
import { useRouter } from 'vue-router';
// eslint-disable-next-line import-x/extensions
import { useAuth } from '@websanova/vue-auth/src/v3.js';
import {
  ONBOARDING, V5_PAGE, resetPageHost, useV5Gate,
} from './shellPage';
import { classicFor, v5OrClassic } from './nav';

// Every v5 page wraps itself in this. The shell (sidebar, top bar, popups) is mounted once by
// V5ShellRoute; this hands it the page's values. page: the sidebar item to highlight. title and
// classic override the page name and the classic fallback for pages that are not in the sidebar.
// rail: an icon-only sidebar for pages that need the width (the 2D viewer).
const props = defineProps({
  page: { type: String, required: true },
  title: { type: String, default: '' },
  classic: { type: String, default: '' },
  rail: { type: Boolean, default: false },
});

const auth = useAuth();
const router = useRouter();
const { allowed, onboarding, ready } = useV5Gate();

watchEffect(() => {
  if (!auth.user()) return;
  // Anyone outside the current audience gets the classic page instead
  if (!allowed.value) router.replace(props.classic || classicFor(props.page));
  // The classic dashboard shows onboarding until a v5 page for it exists
  else if (onboarding.value) router.replace(v5OrClassic(router, ONBOARDING, '/'));
});

// The next page may mount before this one unmounts: only the page that wrote last clears
const host = inject(V5_PAGE, null);
const me = {};
if (host) {
  watchEffect(() => {
    const {
      page, title, classic, rail,
    } = props;
    Object.assign(host.state, {
      page, title, classic, rail,
    });
    host.owner = me;
  });
  onUnmounted(() => { if (host.owner === me) resetPageHost(host); });
}
</script>
